const RTL_LANGS = ['ar'];

export const useRtlVersion = () => {
  const { locale } = useI18n();

  const isRtlVersion = computed(() => RTL_LANGS.includes(locale.value));

  return { isRtlVersion };
};
